import { render, staticRenderFns } from "./FacebookFollow.vue?vue&type=template&id=265c41da"
import script from "./FacebookFollow.vue?vue&type=script&lang=js"
export * from "./FacebookFollow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports